import {useXR} from '@react-three/xr'
import {useEffect, useRef, useState} from 'react'
import {Remote_NotifyVRHeadsetState, Remote_RequestTTS, remoteUserProcessesBridge} from "../../Bridge/Bridge_RemoteUserProcesses.js";
import {useFrame, useThree} from "@react-three/fiber";
import {Vector3} from "three";
import React from "react";
import {store} from "../../../Store/index.js";

// True only when running in the actual headset's browser (eg. Oculus/Meta Quest Browser).
// The WebXR emulator creates a real XRSession in desktop Chrome/Edge, so "session active" alone
// can't distinguish emulator from headset — the UA is the reliable discriminator.
export const RunningInActualVRHeadset = ()=>{
	const ua = navigator.userAgent;
	return /OculusBrowser|Oculus|Quest|Pico|HTC|VIVE|Wolvic/i.test(ua);
};

export const VRHeadsetStateTracker = ()=>{
	const {camera} = useThree();
	const {session} = useXR();
	const vrSettings = store.main.settings.vr;

	const inPhysicalHeadset = RunningInActualVRHeadset();

	let [headsetOn, setHeadsetOn] = useState(false);
	useFrame(()=>{
		// only ever run when (a) we're in the headset's browser, and (b) there is a live XR session
		if (!inPhysicalHeadset || !session) return;
		if (!camera) return;
		// root-space is y-up, so vertical camera position is on y (headset camera lives at root via XROrigin)
		if (!headsetOn && camera.position.y > vrSettings.headsetOnWhenAbove) {
			setHeadsetOn(true);
			Remote_NotifyVRHeadsetState(true);
		} else if (headsetOn && camera.position.y < vrSettings.headsetOffWhenBelow) {
			setHeadsetOn(false);
			Remote_NotifyVRHeadsetState(false);
		}
	});

	return null;
};

export const VRHeadsetStateTracker_old = ()=>{
	const xrInfo = useXR();
	g.xr1 = xrInfo; // temp
	const {session} = xrInfo;

	/*useEffect(()=>{
		if (!session) return;

		const handleVisibilityChange = ()=>{
			if (session.visibilityState === 'visible') {
				console.log('Headset put on')
				Remote_NotifyVRHeadsetState(true);
			} else if (session.visibilityState === 'hidden') {
				console.log('Headset removed')
				Remote_NotifyVRHeadsetState(false);
			}
		};
		session.addEventListener('visibilitychange', handleVisibilityChange);
		return ()=>session.removeEventListener('visibilitychange', handleVisibilityChange);
	}, [session]);*/

	let [headsetOn, setHeadsetOn] = useState(false);
	useFrame(()=>{
		if (!session) return;
		const newHeadsetOn = session.visibilityState == "visible";
		if (newHeadsetOn != headsetOn) {
			setHeadsetOn(newHeadsetOn);
			Remote_NotifyVRHeadsetState(newHeadsetOn);
		}
	});

	//useHeadsetWornDetection();
	//useHeadsetMovementDetection();
	useGLPerformanceDetection();

	//return React.createElement(HeadsetWearDetection, {});
	return null;
};


function HeadsetWearDetection() {
  const [isWorn, setIsWorn] = useState(true)
  const lastFrameTime = useRef<number>(Date.now())
  const frameGaps = useRef<number[]>([])
  
  useFrame(() => {
    const now = Date.now()
    const delta = now - lastFrameTime.current
    lastFrameTime.current = now
    
    // Track the last 10 frame deltas
    frameGaps.current.push(delta)
    if (frameGaps.current.length > 10) {
      frameGaps.current.shift()
    }
    
    // If we have enough samples, check for significant slowdown
    if (frameGaps.current.length === 10) {
      const avgDelta = frameGaps.current.reduce((a, b) => a + b, 0) / 10
      
      // When headset is removed, frame time typically spikes
      // Adjust this threshold based on testing
      if (avgDelta > 50 && isWorn) { // Suggests headset removed
        setIsWorn(false)
        console.log("11Headset likely removed", avgDelta)
      } else if (avgDelta < 30 && !isWorn) { // Back to normal timing
        setIsWorn(true)
        console.log("11Headset likely worn", avgDelta)
      }
    }
  })
  
  return null
}

function useHeadsetWornDetection() {
  const [isWorn, setIsWorn] = useState(true)
  const frameCountRef = useRef(0)
  const intervalRef = useRef<ReturnType<typeof setInterval>|null>(null)
  
  useEffect(() => {
    // Start monitoring frame rate
    let lastFrameCount = 0
    
    const animFrameCallback = () => {
      frameCountRef.current++
      requestAnimationFrame(animFrameCallback)
    }
    
    // Start counting frames
    requestAnimationFrame(animFrameCallback)
    
    // Check frame count periodically
    intervalRef.current = setInterval(() => {
      const currentFrames = frameCountRef.current
      const framesPerSecond = currentFrames - lastFrameCount
      lastFrameCount = currentFrames
      
      // When headset is removed, frame rate drops significantly
      if (framesPerSecond < 30 && isWorn) {
        setIsWorn(false)
        console.log("22Headset likely removed", framesPerSecond)
      } else if (framesPerSecond >= 55 && !isWorn) {
        setIsWorn(true)
        console.log("22Headset likely worn", framesPerSecond)
      }
    }, 1000)
    
    return () => {
      clearInterval(intervalRef.current!)
    }
  }, [isWorn])
  
  return isWorn
}

function useHeadsetMovementDetection() {
  const { origin: player } = useXR()
  const [isWorn, setIsWorn] = useState(true)
  const lastPosition = useRef(new Vector3())
  const noMovementFrames = useRef(0)
  
  useFrame(() => {
    if (!player) return
    
    // Get current head position
    const currentPosition = player.position.clone()
    
    // Check if there's movement (even subtle movement from breathing)
    const movement = currentPosition.distanceTo(lastPosition.current)
    lastPosition.current.copy(currentPosition)
    
    // Human heads always have tiny movements - if none detected for ~1-2 seconds, 
    // headset is likely removed
    if (movement < 0.0001) {
      noMovementFrames.current++
      if (noMovementFrames.current > 90 && isWorn) { // ~1.5 seconds at 60fps
        setIsWorn(false)
        console.log("33Headset likely removed - no movement")
      }
    } else {
      noMovementFrames.current = 0
      if (!isWorn) {
        setIsWorn(true)
        console.log("33Headset likely worn - movement detected")
      }
    }
  })
  
  return isWorn
}

function useGLPerformanceDetection() {
	const { gl } = useThree()
	const gl2 = gl.getContext() as WebGL2RenderingContext;
	const [isWorn, setIsWorn] = useState(true)
	const ext = useRef<{}>(null)
	const query = useRef<WebGLQuery>(null)
	const lastDrawTime = useRef(0)
	const abnormalFramesCount = useRef(0)
	
	useEffect(() => {
		if (!gl2) {
			console.warn("No gl2");
			return
		}
		
		// Try to get the EXT_disjoint_timer_query_webgl2 extension
		ext.current = gl2.getExtension('EXT_disjoint_timer_query_webgl2');
		
		if (!ext.current) {
			console.warn('EXT_disjoint_timer_query_webgl2 not supported')
			return
		}
		
		// Create initial query
		query.current = gl2.createQuery()
		
		const checkInterval = setInterval(() => {
			if (lastDrawTime.current > 0) {
				if (lastDrawTime.current < 0.1 && isWorn) {
					// Extremely fast draws might indicate the GPU is skipping work
					abnormalFramesCount.current++
					
					if (abnormalFramesCount.current > 5) {
						console.log("Abnormally fast GPU timing - headset might be removed")
						setIsWorn(false)
						abnormalFramesCount.current = 0
					}
				} else if (lastDrawTime.current > 1.0 && !isWorn) {
					// Back to normal timing range
					console.log("Normal GPU timing restored - headset might be worn")
					setIsWorn(true)
					abnormalFramesCount.current = 0
				}
			}
		}, 1000)

		console.log("Setup done!");
		
		return () => clearInterval(checkInterval)
	}, [gl2, isWorn])
  
  // Hook into the render loop to measure draw times
  useThree(({ gl }) => {
		const gl2 = gl.getContext() as WebGL2RenderingContext;

		const oldRender = gl.render
		gl.render = function(...args) {
			if (ext.current && query.current) {
				gl2.beginQuery(ext.current["TIME_ELAPSED_EXT"], query.current)
				oldRender.call(gl, ...args)
				gl2.endQuery(ext.current["TIME_ELAPSED_EXT"])
				
				// Check query results from previous frame
				const available = gl2.getQueryParameter(query.current, gl2.QUERY_RESULT_AVAILABLE)
				const disjoint = gl2.getParameter(ext.current["GPU_DISJOINT_EXT"])
				
				if (available && !disjoint) {
					const timeElapsed = gl2.getQueryParameter(query.current, gl2.QUERY_RESULT)
					lastDrawTime.current = timeElapsed / 1000000.0 // Convert to ms
				}
			} else {
				oldRender.call(gl, ...args)
			}
		};
		console.log("Setup2 done!");
		return ()=>{
			gl.render = oldRender
		};
  })
  
  return isWorn
}